import { INACTIVE_CURRENCY_ERROR_CODE } from '@webapp/modules/purchasing/business-logic/use-cases/constants/inactiveCurrencyErrorCode'
import { LegalEntityErrorCodes } from '@webapp/modules/purchasing/business-logic/use-cases/constants/legalEntityErrorCodes'
import {
  OrderItemInteractiveFields,
  type OrderItemInteractiveFieldEnum,
} from '@webapp/modules/purchasing/entities/enums/OrderItemInteractiveFieldEnum'

// The item errors the form and card show, keyed by payload field.
const DISPLAYED_ITEM_FIELD_ERRORS: Partial<
  Record<string, { field: OrderItemInteractiveFieldEnum; code: string }>
> = {
  currency: {
    field: OrderItemInteractiveFields.CURRENCY,
    code: INACTIVE_CURRENCY_ERROR_CODE,
  },
  pref_vendor: {
    field: OrderItemInteractiveFields.VENDOR,
    code: LegalEntityErrorCodes.VENDOR_NOT_AVAILABLE_FOR_LEGAL_ENTITY,
  },
}

/** The item form field an API field error belongs on, or null when the UI doesn't show it. */
export const mapOrderItemApiFieldError = (
  apiField: string,
  code: string
): Nullable<OrderItemInteractiveFieldEnum> => {
  const displayedError = DISPLAYED_ITEM_FIELD_ERRORS[apiField]
  return displayedError?.code === code ? displayedError.field : null
}
